import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { Layout } from 'app/views/presentations/layouts/layout';

@NgModule()
export class LayoutWrapperModule {

    public static wrapLayout(widget: Type<Layout>): ModuleWithProviders {
        return {
            ngModule: LayoutWrapperModule,
            providers: [{
                provide: Layout,
                useClass: widget,
                multi: true
            }]
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layoutWrapper.module.ts